export default function Footer() {
  return (
    <footer id="footer" className="py-14 md:py-16 px-4 md:px-6 bg-secondary-900 text-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 mb-10">
          <div className="lg:col-span-1">
            <h3 className="font-heading text-lg font-bold text-background-50 mb-3">久久影视</h3>
            <p className="text-xs md:text-sm text-secondary-300 leading-relaxed">
              久久影视专注于最新电视剧更新与最新电影上映动态追踪。
              影视更新快、新剧抢先看、最新综艺在线，高清不卡，追剧党首选。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3">快速导航</h4>
            <div className="flex flex-col gap-2">
              <a href="#features" className="text-xs md:text-sm text-secondary-300 hover:text-background-50 transition-colors duration-200 whitespace-nowrap cursor-pointer">追剧为什么选久久</a>
              <a href="#cards" className="text-xs md:text-sm text-secondary-300 hover:text-background-50 transition-colors duration-200 whitespace-nowrap cursor-pointer">热播精选</a>
              <a href="#index" className="text-xs md:text-sm text-secondary-300 hover:text-background-50 transition-colors duration-200 whitespace-nowrap cursor-pointer">专题合集</a>
              <a href="#media" className="text-xs md:text-sm text-secondary-300 hover:text-background-50 transition-colors duration-200 whitespace-nowrap cursor-pointer">精彩抢先看</a>
              <a href="#ranking" className="text-xs md:text-sm text-secondary-300 hover:text-background-50 transition-colors duration-200 whitespace-nowrap cursor-pointer">热度榜单</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3">内容分类</h4>
            <div className="flex flex-col gap-2">
              <span className="text-xs md:text-sm text-secondary-300 whitespace-nowrap">最新电视剧更新</span>
              <span className="text-xs md:text-sm text-secondary-300 whitespace-nowrap">最新电影上映</span>
              <span className="text-xs md:text-sm text-secondary-300 whitespace-nowrap">最新综艺在线</span>
              <span className="text-xs md:text-sm text-secondary-300 whitespace-nowrap">高分口碑推荐</span>
              <span className="text-xs md:text-sm text-secondary-300 whitespace-nowrap">海外剧集精选</span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3">合作伙伴</h4>
            <p className="text-xs md:text-sm text-secondary-400 leading-relaxed">
              久久影视与多家优质内容平台保持良好合作关系，共同为追剧党提供更丰富的影视资讯与内容导航服务。
            </p>
          </div>
        </div>

        <div className="border-t border-secondary-700 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-400">
            &copy; 2026 久久影视 | 追剧党首选 · 高清不卡 · 影视更新快
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-secondary-400 whitespace-nowrap">最新电视剧更新</span>
            <span className="w-px h-3 bg-secondary-700"></span>
            <span className="text-xs text-secondary-400 whitespace-nowrap">最新电影上映</span>
            <span className="w-px h-3 bg-secondary-700"></span>
            <span className="text-xs text-secondary-400 whitespace-nowrap">影视更新快</span>
          </div>
        </div>
      </div>
    </footer>
  );
}